import { compose } from 'redux';
import { branch, renderComponent, withProps } from 'recompose';
import { ConfigService } from '../../../../services/config-service';
import { ADVERT_VIEW_MODE_TYPED, getAdvertViewMode } from '../../../../helpers/advert/advert';
import { GridView } from './views/grid';
import { SliderView } from './views/slider';

export const AdvertLinkViewController = compose(
  withProps(() => {
    const { viewMode, gridConfiguration, sliderConfiguration } = ConfigService.get('DASHBOARD.widgets.adverts', {});

    const mode = getAdvertViewMode(viewMode);

    return {
      mode,
      ...(mode === ADVERT_VIEW_MODE_TYPED.grid && { gridConfiguration }),
      ...(mode === ADVERT_VIEW_MODE_TYPED.slider && { sliderConfiguration })
    };
  }),
  branch(({ mode }) => mode === ADVERT_VIEW_MODE_TYPED.slider, renderComponent(SliderView))
)(GridView);

AdvertLinkViewController.displayName = 'AdvertLinkViewController';
